import { useNavigate } from "react-router-dom"
import { ArrowLeft, Home } from "lucide-react"
import { Button } from "@/components/ui/button"
import { usePageSEO } from "@/lib/usePageSEO"
import { APP_NAME } from "@/lib/appConfig"

export default function NotFoundPage() {
  const navigate = useNavigate()

  // nginx serves the SPA shell with a 200 for any unmatched path, so without
  // this every bad URL looks to Google like a real page duplicating the landing
  // content. Google renders JS, so the noindex does get picked up here.
  usePageSEO({
    title: `Page not found | ${APP_NAME}`,
    description: "This page doesn't exist or was moved.",
    path: "/404",
    noindex: true,
  })

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-background">
      <div className="w-full max-w-sm text-center">
        <div className="w-24 h-24 rounded-3xl bg-muted flex items-center justify-center mx-auto mb-6">
          <span className="text-4xl font-bold text-muted-foreground">404</span>
        </div>
        <h1 className="text-xl font-bold mb-2">Page not found</h1>
        <p className="text-sm text-muted-foreground mb-8">
          This page doesn't exist or was moved. Check the address and try again.
        </p>
        <div className="flex flex-col gap-3 items-center">
          <Button
            className="h-11 px-6 rounded-xl w-full max-w-[200px]"
            onClick={() => navigate("/dashboard")}
          >
            <Home className="h-4 w-4 mr-2" />
            Go to Dashboard
          </Button>
          <Button
            variant="ghost"
            className="h-10 px-4 rounded-xl"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go back
          </Button>
        </div>
      </div>
    </div>
  )
}
